<template>
<div>

<button type="button" @click="setTables()"  class="btn btn-info  mb-2 ml-2">
  <i style="color:yellow" v-bind:class="show_tables ? 'far fa-eye-slash' : 'far fa-eye'" class="mr-2" aria-hidden="true"></i>
  {{show_tables ? 'NASCONDI TABELLE' : 'MOSTRA TABELLE'}}</button>
 
<div v-if="show_tables">
<div class="row">
    <div class="col-sm-3">
        <color-list v-bind:selection="productColors"  @update="setColorList"></color-list>
    </div>
    <div class="col-sm-9">
        <size-list v-bind:selection="productSizes" @update="setSizeList"></size-list>
    </div>  
</div>
</div>

<!-- TABLE -->
<div class="dataTable">              
  <table class="table table-bordered table-sm" id="dataGrid">
    <thead class="thead-light">
      <tr>
        <th class="text-center"
        
          v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
           v-for="(key,index) in cols" :key="index">
       
          <span 
           v-bind:style="{ color:  key!='COLORE' ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
           >{{key}}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr  v-for="(item, index1) in rows" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
        <div style="color : blue" v-if="key == 'COLORE'" >
        <div class="form-group row">
            <div class="col-auto">
                 <label for="staticColor" class="col-form-label ml-3 text-nowrap">
                  
                  <!--<i v-if="item['disabled']" style="color:black" :title="'Colore '"  class="fas fa-ban mr-1" aria-hidden="true"></i>-->
                  
                  <strong>{{item[key].toUpperCase()}}</strong>
                  <i @click="deleteRowColor(item)" data-toggle="tooltip" :title="item['deleteRow']==0 ? 'Azzera qtà colore' : 'Ripristina qtà colore'"  :style="{color:item.deleteRow==0 ?'black':'red'}" :class="[item['deleteRow'] == 0 ? 'far fa-edit' : 'fas fa-edit' ]" class="deleteRow center-text ml-3" aria-hidden="true"></i>  
                </label>
                 
                 <input  v-model = "item['supplierColor']" class="form-control inputClass " type="text"  :placeholder="'Codice colore fornitore'">
                 
            </div>
         
            
        </div>
        
        </div> 
         <div v-else>
         
          <div class="col">
          
          <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div style="color:brown" :style="{borderWidth:item[key]['order_qty'] == 0 ? 'medium':'', borderColor: item[key]['order_qty'] == 0 ? 'red':''}"  class="input-group-text order">Ord.</div>
          </div>
          <input v-on:keydown="keyHandler($event,'Num')" v-model = "item[key]['order_qty']" class="form-control" type="number"  :placeholder="''" >
          
          </div>

          </div>

            <div class="col">
          <div class="input-group ">
          <div class="input-group-prepend">
            <div style="color:green" class="input-group-text">Con.</div>
          </div>
          
          <input  v-on:keydown="keyHandler($event,'Num')"  v-model = "item[key]['delivered_qty']" class="form-control inputClass" type="number"  :placeholder="''" >
          </div>
            </div>
         
         
         </div>
        </td>
      </tr>
    </tbody>
  </table>

<!-- Table -->
 </div>
  
  <div class="row ml-2">

  <div class="col-6  ">
    <h4 style="color:black" class="text-right mr-3">Totale q.tà in ordine  <span  class="badge badge-warning ml-3">{{total}}</span></h4>
  </div>

  </div>

  <alert-box class="mt-2 mb-2"  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
    
  <button :disabled="spinner" @click="checkOut()" class="btn btn-primary float-right mr-3">
     <i class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
    PROCEDI
     <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>
 
</div> 
</template>

<script>

import alertBox                    from '@/components/common/AlertBox.vue';
import {eanCD,createEAN13}         from '@/functions';   
import sizeList                    from '@/components/order/SizeList.vue';

import colorList                   from '@/components/order/ColorList.vue';


import api                         from '@/api'
import productInfo                 from '@/components/product/ProductInfo.vue';
import keyHandler                  from '@/components/mixins/keyHandler'


import { mapGetters }  from 'vuex';

export default {
   mixins: [keyHandler],
   components: {sizeList,colorList,alertBox,productInfo
     
  },
  props : ['order','productId'],
  data () {
    return {      
    
    items                 : [],
    show_tables           : false,
    rows                  : [],
    cols                  : [],
    productColors         : [],
    productSizes          : [],
    supplierColors        : [], 
    productBarcodes       : [],
    total                 : 0,
    counter               : 0,
    msg                   : {
        title : '',
        body  : '',
        type  : 1
    },

    /*discount              : 0,*/
    spinner               : false
  
    
    }
  },

  computed: 
  {   
    
   ...mapGetters(['company']),
   
  },
  directives: {
  focus: {
    // directive definition
    inserted: function (el) {
      
      if(el.id=='id_01')
      {
        el.focus()
      }
    }
  }
  },
  created()
  {  
    this.getData()
  },

  watch: 
  {
        
    'rows' : 
    {
      
      deep: true,  
      handler : function(newValue) 
      {                
        this.total = 0
        for(var i = 0; i < newValue.length; i++) 
          {
            var obj = newValue[i];
            Object.entries(obj).forEach(entry => 
            {
              let key = entry[0];
              let value = entry[1]['order_qty'];
              if (key != 'colorId' && key != 'COLORE' && key != 'supplierColor'&& key != 'deleteRow' )
              {

                this.total += Number(value)
              }
                      
            });  
          }                
      }

    }
    
  
  },
      
  methods: 
  {

    deleteRowColor(row)
    {   
    if(row.deleteRow == 0)
        {   
        this.cols.forEach(col=>{                    
          if(col != 'COLORE' && col != '')
          {
           
            row[col].order_qty = 0

          }
       })
       row.deleteRow = 1
    }
    else
    {
         this.cols.forEach(col=>{                    
          if(col != 'COLORE' && col != '')
          {
           
            row[col].order_qty = row[col].saved_qty

          }
       })
       row.deleteRow = 0
    }  
    },
  async saveData(data)
  {
   
    
    this.spinner = true
    
    var sp    = {'sp':'spUpdateSupplierOrderDetail'}
    var json  = Object.assign(data, sp);

    await api.post(json).then(async res => {
      if(res.status==200)
        {
          
          //let productQty = await this.checkProductHasQty()

          const productHasQty = res.data.recordsets[0].length 
         
         
         
         this.$emit('update',productHasQty) 

        }
        else if(res.status==500)
        {
         
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res.data
          this.msg.type = 1

        } 
        else
        {
         
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res
          this.msg.type = 1
                 
        } 
    }).catch(err => 
    {
     
      this.msg.title = 'ATTENZIONE '
      this.msg.body = err.message
      this.msg.type = 1

    }).finally(() => {
      this.spinner = false
    });
    
  },
  

    setTables()
    {
      
     
      this.show_tables = !this.show_tables
      this.$nextTick(function () {
        $('input:visible:enabled:first').focus(); 
      })
     
      
    },

    copyQty()
    {

    },

    setColorList(colors)
    {
      
      

      this.productColors = colors
      
      //this.show_tables = false
      this.createGrid(this.productColors,this.productSizes,this.items)
     
      
    },
    setSizeList(sizes)
    {
      this.productSizes = sizes
      //this.show_tables = false
      this.createGrid(this.productColors,this.productSizes,this.items)
      

    },

    createGrid(colors,sizes,items)
    {

      this.cols = []
      this.rows = []
      this.cols.push('COLORE')
      sizes.forEach(item =>
      {
        this.cols.push(item.size)
      }) 
             
      var arr = []
      var obj = {}
      var tmp = {}
      
      

      colors.forEach(color => 
      {
        obj  = {}
        obj.COLORE        = color.color
        obj.colorId       = color.colorId
        obj.deleteRow     = 0
        
        var colorId       = this.supplierColors.filter(item => (item.colorId == color.colorId))
        
        obj.supplierColor = colorId.length > 0 ?  colorId[0].supplierColor  : ''
        
        sizes.forEach(size => 
        {   

          var item          = items.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId))    
          
          if(item.length > 0)
          {
            
            tmp = {}    
            tmp['row_Id']          = item[0].row_Id
            tmp['qty']             = Number(item[0].order_qty)                            
            tmp['order_qty']       = item[0].order_qty
            tmp['saved_qty']       = item[0].order_qty
            tmp['costPrice']       = item[0].cost_price

            tmp['delivered_qty']   = Number(item[0].delivered_qty)
            tmp['barcode']         = item[0].barcode
            tmp['sizeId']          = size.sizeId
            
            tmp['supplierColor']   = item[0].supplierColor
            
            obj[size.size]         = tmp 

          }
            else
            {
            
              tmp = {}
              tmp['row_Id']        = 0
              tmp['qty']           = 0
              tmp['order_qty']     = 0
              tmp['saved_qty']     = 0
              tmp['delivered_qty'] = 0
              let barcode          = this.productBarcodes.filter(item=> item.colorId == color.colorId && item.sizeId == size.sizeId)
              if(barcode.length == 0)
              {
                tmp['barcode']       = createEAN13(this.productId,++this.counter)
              }
              else
              {
                tmp['barcode']     = barcode[0].barcode
              }
              tmp['sizeId']        = size.sizeId
              tmp['costPrice']     = 0
                            
              tmp['supplierColor'] = ''
              obj[size.size]       = tmp 
            }

        })
        arr.push(obj)
      })
    

    this.rows = arr
    
   // console.log('DATA',this.rows)

    this.$nextTick(function () {
        $('input:visible:enabled:first').focus(); 
      })            
      
      
    },

   
   checkOut() 
    {
     
      this.msg.title = ''
      if(this.rows.length== 0 || this.cols.length == 1)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Inserire Colore e Misura.'
        this.msg.type = 1
        return
      }
      if(this.total == 0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Operazione non consentita con un solo colore.Eliminare il prodotto dalla lista prodotti.'
        this.msg.type = 1
        return
      }

      var items = []
      this.rows.forEach(item =>{

        Object.entries(item).forEach(entry => 
            {
              let key = entry[0];
              let colorId = 0    
              let sizeId = 0   
              let supplierColor = ''
              // ONLY SIZES Keys
              if (key != 'colorId' && key != 'COLORE' && key != 'supplierColor' && key != 'deleteRow')
              {
                  
                  colorId       = item.colorId
                  supplierColor = item.supplierColor
                  sizeId        = entry[1]['sizeId']
                  
                  

                  
                    items.push({'row_Id': entry[1]['row_Id'], 'barcode': entry[1]['barcode'],
                    'order_qty' : Number(entry[1]['order_qty']),
                    'delivered_qty' : Number(entry[1]['delivered_qty']),
                    'qty': entry[1]['qty'],'costPrice' : entry[1]['costPrice'],'vat':0,
                    
                    'colorId':colorId,'sizeId':sizeId,'supplierColor':supplierColor})
                  
                                  
              }
                      
            });  
        
      })
     
    var data = {'orderId':this.order.orderId,'productId':this.productId,'counter':this.counter}
    data.body = items
    
    
    

    this.saveData(data)      
    },  
   
    

    async getData()
    {
        
        var data      = {'orderId' : this.order.orderId, 'productId' : this.productId}
        var sp        = {'sp'      : 'spOrderDetailProductQty'}
        var json      = Object.assign(data, sp);

        await api.post(json).then(res => {
          if(res.status==200)
            {
              var sizes            = res.data.recordsets[1]  
              var colors           = res.data.recordsets[2]
              this.items           = res.data.recordsets[0]
              this.counter         = res.data.recordsets[4][0].counter
              this.productBarcodes = res.data.recordsets[5]
              this.supplierColors  = []
              colors.forEach(item => 
              {
                item.disabled = true
                this.supplierColors.push({'colorId':item.colorId,'supplierColor':item.supplierColor})  
              }
              )
                            
              this.createGrid(colors,sizes,this.items)
              
             // console.log(colors)
              this.productColors = colors
              
             
              this.productSizes = sizes
              
              

            }
            else if(res.status==500)
            {
             

              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
              

            } 
            else
            {
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
            } 
        }).catch(err => 
        {
         
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1  
        }).finally(() => {
          this.spinner = false
        });

        
    },

   
    }
  
}
</script>

<style scoped>


.dataTable {
position: relative;
height: 400px;
overflow: auto;
}
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
.badge-warning{
  font-size:24px;  
}
.inputClass{
  font-weight       : bold;
  
  }
.misura
{
  color        : coral;
  font-size    : 12px;
}

input[type=text]:disabled {
  background : white;
  color      : navy
}
h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
.deleteRow
{
  cursor : pointer; 
}
</style>